import json from "../../json/logStreamerTypes.json";

export default async () => {
  return JSON.parse(JSON.stringify(await json));
};
